module.exports = __webpack_public_path__ + "media/images/img-wizard-45521142fdf530f7dabc6fc5afbe4ca4.png";